import { useQuery } from "@tanstack/react-query";
import { fine } from "./query";
import { PostModel } from "common/models/BaseModel";
import {
  IFineGridFilter,
  IFineCollectionListGridPostModel,
  IFineReportsFilter,
} from "./types";

export function GetFines(model: PostModel<IFineGridFilter> | undefined) {
  return useQuery(fine.list(model));
}

export function GetFine(Id: string | number) {
  return useQuery({
    ...fine.getById(Id),
    enabled: !!Id,
  });
}

export function GetFineView(id: string | number, isOpen: boolean) {
  return useQuery({
    ...fine.getViewById(id),
    enabled: !!id && isOpen,
  });
}

export function GetFineCollectionlist(
  model: IFineCollectionListGridPostModel | undefined
) {
  return useQuery({
    ...fine.getFinelist(model),
    enabled: model?.filter?.memberID !== undefined,
  });
}

export function ReportsCount(model: IFineReportsFilter | undefined) {
  return useQuery(fine.reportsCount(model));
}
